import { DSCheckbox, DSInlineField } from "@hundred5/design-system";
import { useField } from "formik";
import { ReactNode } from "react";

interface FormikCheckboxFieldProps {
  id: string;
  name: string;
  label: ReactNode;
  value?: string;
  hideError?: boolean;
}

export const FormikCheckboxField = (props: FormikCheckboxFieldProps) => {
  const [field, meta] = useField<any>({
    name: props.name,
    type: "checkbox",
    value: props.value,
  });

  return (
    <DSInlineField
      for={props.id}
      label={props.label}
      error={!props.hideError && meta.touched ? meta.error : undefined}
    >
      <DSCheckbox
        id={props.id}
        error={!props.hideError && meta.touched && meta.error != null}
        {...field}
      />
    </DSInlineField>
  );
};
